export const SKILLS = [
  'Attack', 'Strength', 'Defence', 'Ranged', 'Prayer', 'Magic',
  'Runecrafting', 'Construction', 'Constitution', 'Agility', 'Herblore',
  'Thieving', 'Crafting', 'Fletching', 'Slayer', 'Farming', 'Hunter',
  'Mining', 'Smithing', 'Fishing', 'Cooking', 'Firemaking', 'Woodcutting',
  'Divination', 'Dungeoneering', 'Invention', 'Archaeology', 'Summoning'
] as const;

export type SkillId = (typeof SKILLS)[number];

export const RESOURCE_BY_SKILL: Record<SkillId, string> = {
  Attack: 'weaponry',
  Strength: 'might',
  Defence: 'armour',
  Ranged: 'arrowheads',
  Prayer: 'faith',
  Magic: 'arcana',
  Runecrafting: 'runes',
  Construction: 'planks',
  Constitution: 'vitality',
  Agility: 'reflexes',
  Herblore: 'herbs',
  Thieving: 'secrets',
  Crafting: 'cloth',
  Fletching: 'feathers',
  Slayer: 'trophies',
  Farming: 'crops',
  Hunter: 'hides',
  Mining: 'ore',
  Smithing: 'bars',
  Fishing: 'fish',
  Cooking: 'food',
  Firemaking: 'charcoal',
  Woodcutting: 'wood',
  Divination: 'memories',
  Dungeoneering: 'shards',
  Invention: 'components',
  Archaeology: 'artifacts',
  Summoning: 'charms'
};

export const RESOURCES = [...new Set(Object.values(RESOURCE_BY_SKILL))] as const;
export const SKILL_BY_RESOURCE = Object.fromEntries(
  Object.entries(RESOURCE_BY_SKILL).map(([skill, resource]) => [resource, skill])
) as Record<string, SkillId>;

/**
 * A directed dependency web: every Hall uses the next two suppliers in a
 * thematic production chain. Every resource supports exactly two Halls, no
 * Hall uses its own resource, and reciprocal A <-> B dependencies are banned.
 */
export const BUILDING_SUPPORT_RESOURCES_BY_SKILL: Record<SkillId, readonly [string, string]> = {
  Attack: ['cloth', 'charcoal'],
  Crafting: ['charcoal', 'wood'],
  Firemaking: ['wood', 'planks'],
  Woodcutting: ['planks', 'might'],
  Construction: ['might', 'vitality'],
  Strength: ['vitality', 'herbs'],
  Constitution: ['herbs', 'crops'],
  Herblore: ['crops', 'food'],
  Farming: ['food', 'fish'],
  Cooking: ['fish', 'feathers'],
  Fishing: ['feathers', 'arrowheads'],
  Fletching: ['arrowheads', 'hides'],
  Ranged: ['hides', 'charms'],
  Hunter: ['charms', 'faith'],
  Summoning: ['faith', 'memories'],
  Prayer: ['memories', 'arcana'],
  Divination: ['arcana', 'runes'],
  Magic: ['runes', 'shards'],
  Runecrafting: ['shards', 'trophies'],
  Dungeoneering: ['trophies', 'armour'],
  Slayer: ['armour', 'bars'],
  Defence: ['bars', 'ore'],
  Smithing: ['ore', 'components'],
  Mining: ['components', 'artifacts'],
  Invention: ['artifacts', 'secrets'],
  Archaeology: ['secrets', 'reflexes'],
  Thieving: ['reflexes', 'weaponry'],
  Agility: ['weaponry', 'cloth']
};
